webpackJsonp([170786371021445],{

/***/ 874:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. <br />\nI will answer to your message as soon as possible.</p>","frontmatter":{"title":"Success"}},"site":{"siteMetadata":{"facebook":{"appId":"1184472234930745"}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-a73f7b229c1a00d66d2e.js